var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan2Timebased = function SvgDAhuSignalFan2Timebased(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 129,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,119c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10s-10-4.5-10-10S425.5,119,431,119 M431,118 c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S437.1,118,431,118L431,118z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431,122.1c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9s-6.9-3.1-6.9-6.9S427.2,122.1,431,122.1 M431,121.1 c-4.3,0-7.9,3.5-7.9,7.9c0,4.3,3.5,7.9,7.9,7.9s7.9-3.5,7.9-7.9S435.3,121.1,431,121.1L431,121.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.4,132.3l-2.6-3.2c0,0,0-0.1,0-0.1c0-0.2-0.1-0.4-0.3-0.6v-4.1h-1v4.1c-0.2,0.1-0.3,0.4-0.3,0.6 c0,0.4,0.4,0.8,0.8,0.8l0,0l2.6,3.1L434.4,132.3L434.4,132.3z"
  })))));
};
export default SvgDAhuSignalFan2Timebased;